import { API_ROUTE_CBO } from '../../ApiRoute';
import ApiService from '../../ApiService';
import ApiServiceBase from '../../ApiServiceBase';
import { ServerType, ServiceType } from '../../ServiceType.data';
import { storage, STORAGE_CONSTANTS } from '../../LocalStorage';
import { AIPPortletsModel, IAIPDataPayload, IConfigValidateRequest, IConfigValidateResponse } from '../../../models/cbo/AIPPortletsModel';
import {
  AIPProjectReportModel,
  AIPReportActivitiesModel,
} from '../../../models/cbo/AIPDashboardReportModel';

/**
 * Service class for handling AI Assist Portlets related operations.
 */
export class AIPPortletsService {
  /**
   * ApiServiceBase instance for making API calls.
   */
  private readonly cboService: ApiServiceBase = new ApiService(ServiceType.None, ServerType.cbo);

  public getAIPData(data: IAIPDataPayload): Promise<AIPPortletsModel> | AIPPortletsModel {
    const isEngagement = JSON.parse(
      storage.getItem(STORAGE_CONSTANTS.isEngagement) ?? 'false',
    ) as boolean;
    const route: string[] = [
      `${isEngagement ? API_ROUTE_CBO.GET_ENGAGEMENT_AIP_DATA : API_ROUTE_CBO.GET_PURSUIT_AIP_DATA}`.replace(
        ':id',
        data.engagementId,
      ),
    ];
    return this.cboService.get({ route: route, query: { reportType: data.reportType } });
  }

  public getAIPProjectsStatus(): Promise<AIPProjectReportModel> | AIPProjectReportModel {
    const route: string[] = [API_ROUTE_CBO.GET_AIP_PROJECTS_STATUS];
    return this.cboService.get({ route: route });
  }

  public getAIPProjectsActivities(
    id: string,
  ): Promise<AIPReportActivitiesModel> | AIPReportActivitiesModel {
    const route: string[] = [`${API_ROUTE_CBO.GET_AIP_PROJECTS_ACTIVITIES}`.replace(':id', id)];
    return this.cboService.get({ route: route });
  }

  public getValidateConfiguration(
    body: IConfigValidateRequest,
  ): Promise<IConfigValidateResponse> | IConfigValidateResponse {
    const route: string[] = [`${API_ROUTE_CBO.VALIDATE_KEYASSET_CONFIG}`];
    return this.cboService.post({ route: route }, body);
  }
}

const aipPortletsService = new AIPPortletsService();
export default aipPortletsService;
